import React from "react";
import { BiLoaderAlt } from "react-icons/bi";

const PathItem = ({ itemTitle, itemValue, itemIcon: Svg }) => {
  return (
    <article className="flex items-center rounded-lg border border-pasteBlue md:border-lightBlue dark:border-darkSlateBlue px-6 h-[97px] md:h-29">
      <div className="flex items-center gap-3">
        <div className="w-13 h-13 flex justify-center items-center">{Svg}</div>
        <div>
          <h3 className="mb-2 text-semiBlack dark:text-semiWhite text-sm leading-4 tracking-letterSpacingSmall">
            {itemTitle}
          </h3>
          <p className="text-black dark:text-white text-2xl md:text-[32px] leading-6 font-semibold uppercase">
            {itemValue ? itemValue :  <BiLoaderAlt className="animate-spin text-gray-50" />}
          </p>
        </div>
      </div>
    </article>
  );
};

export default PathItem;
